<template>
	<div>
		<header>
		    <i></i>
		    <a class="back" @click="goBack">东方号</a>
		</header>
		<div class="stepContainer">
		    <div class="step">
		        <div class="icon-step active"></div>
		        <div class="name">账号注册</div>
		    </div>
		    <div class="step-line bg-disabled"></div>
		    <div class="step">
		        <div class="icon-step bg-disabled"></div>
		        <div class="name">类型选择</div>
		    </div>
		    <div class="step-line bg-disabled"></div>
		    <div class="step">
		        <div class="icon-step bg-disabled"></div>
		        <div class="name">资料填写</div>
		    </div>
		</div>
		<div class="page">
		    <div class="main">
		        <h3>手机号注册</h3>
		        <div class="row">
		            <input id="code" type="text" placeholder="请输入手机号" v-model="registParams.mobile" @blur="checkMobile"/>
		        </div>
                 <div class="row">
		            <input id="psw" type="password" placeholder="请设置密码" v-model="registParams.password"/>
		        </div>
		        <div class="row" v-if="codeImg">
		            <input id="img-code" class="reset-input" type="text" placeholder="图片验证码" v-model="registCodeParams.authcode"/>
		            <img id="codeImg" :src="codeImg" alt="验证码" @click="changeCodeImg"/>
		        </div>
		        <div class="row">
		            <input id="verifycode" type="text" placeholder="请输入验证码" v-model="registParams.verifycode"/>
		            <button type="button" id="codeBtn" @click="registCode" :class="btnDisabled ? 'disabled' : ''" v-if="!btnDisabled">发送验证码</button>
		            <button type="button" id="codeBtn" @click="registCode" :class="btnDisabled ? 'disabled' : ''" v-if="btnDisabled">重发（{{codeTimerNum}}s）</button>
		        </div>
		       
		        <!-- <div class="row">
		            <input id="psw" type="text" placeholder="请输入邀请码（选填）" v-model="registParams.invitationcode"/>
		        </div> -->
		        <div class="row row-tips f-warn">
		            <p>{{tips}}</p>
		        </div>
		        <div class="row-agree">
		            <label for="weuiAgree" class="weui-agree">
		                <input id="weuiAgree" type="checkbox" v-model="agreeStatus"/>
		                <span>
		                    已阅读并同意<a @click="goProtocol" class="btn-protocol">《东方号协议》</a>
		                </span>
		            </label>
		        </div>
		        <div :class="agreeStatus ? 'btn-submit':'btn-submit disabled'" @click="regist">注册</div>
		    </div>
		</div>
		<footer class="b-default copyright">
		    <p>©上海嵩智文化传播有限公司（tt.cn）版权所有 </p>
		</footer>
		<!-- 弹出框 -->
		<div v-if="maskShow" class="mask">
		    <div class="mask-info">
		        <h3 class="mask-title">提示</h3>
		        <p class="mask-text">{{maskText}}</p>
		        <a class="mask-btn" @click="goRegistType">确认</a>
		    </div>
		</div>
	</div>	
</template>
<script>
	import {regist, registCode,checkMobile,loginCodeImg} from './../../axios/api'
    // 线上环境
   // const loginCodeImg = 'http://mpserver.tt.cn/east-usercenter/util/getVerifyImgCode'
    // 测试环境
    // const loginCodeImg = 'http://tt.mp.eastday.com:8581/mauthimage'
	export default {
		name: 'RegistUser',
		data (){
			return {
				agreeStatus: false,
				codeImg: '',
				registParams: {
		            mobile: '',
		            password: '',
		            verifycode: '',
				},
				registCodeParams: {
					authcode: ''
				},
				tips: '字母、数字或者引文符号，6-12位。必须包含数字、英文字母',
				judgeRule: [
			        {
			            ele: 'mobile',
			            func: function(val) {
			                let ifm = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1})|(17[0-9]{1}))+\d{8})$/.test(val);
			                return ifm;
			            },
			            error:'请输入正确的手机号'
			        },
		         	{
			         	ele: 'verifycode',
			         	func: function (val) {
			         		let ifm =/^\d{4,6}$/.test(val);
			         		return ifm;
			         	},
			         	error:'请输入正确的验证码'
		         	},
			        {
			            ele: 'password',
			            func: function(val) {
			                let reg = /^(?=.*[a-zA-Z])(?=.*\d)[~!@#$%^&*()_+`\-={}:";'<>?,.\/\w]{6,12}$/;
			                let ifm = reg.test(val);
			                return ifm;
			            },
			            error:'请输入正确格式的密码！'
			        }
			    ],
			    btnDisabled: false,
			    codeTimerNum: 120,
			    maskShow: false,
			    maskText: '',
			}
		},
		mounted(){
			
		},
		methods:{
			checkMobile(){
				let item = this.judgeRule[0];
			  	if(!item.func(this.registParams.mobile)){
            		  this.$layer.dialog({
                                content: "请输入正确的手机号",
                                time: 3000
					  })
					  return;
				}
				checkMobile({mobile:this.registParams.mobile}).then(res =>{
					if(res.code == "100"){
						this.changeCodeImg();
					}else{
						this.$layer.dialog({
									content: res.msg,
									time: 3000
						})
					}
				}).catch(err =>{

				});
			},
			goBack (){
				this.$router.go(-1);
			},
			goProtocol (){
				window.open(window.location.origin + '#/Protocol')
			},
			goRegistType (){
				this.$router.push({path: '/RegistType'})
			},
            changeCodeImg (){
				//this.codeImg = loginCodeImg+"?r="+Math.random();
				  this.codeImg =   loginCodeImg+'?account='+this.registParams.mobile+'&status='+Math.random();
            },
			checkAll (params){
                let that = this;
                let ifok = this.judgeRule.every(function(item) {
                    let ele = item.ele;
                    let func = item.func;
                    let ifm = func(params[ele]);
                    let error = item.error;

                    if (ifm) {
                        that.tips = '';
                    } else {
                        that.tips = error;
                    }
                    return ifm;
                });
                return ifok;
            },
            regist (){
            	if(!this.agreeStatus){
            		return;
            	}
            	let params = this.registParams;
            	if(!this.checkAll(params)){
            		return false;
            	}
            	let that = this;
            	regist({
					 mobile: that.registParams.mobile,
                     pwd: that.registParams.password,
                     v_code: that.registParams.verifycode,
				}).then( result => {
            		if (result.code == '0') {
						localStorage.setItem('accountPhone',that.registParams.mobile);
            			that.$router.push({path: '/RegistType'})
		            // } else if(result.stat == 10){
		            //   	that.maskShow = true;
		            //   	that.maskText = result.msg
		            }else {
					   // that.tips = res.msg;
					   this.$layer.dialog({
									content: result.msg,
									time: 3000
						})
		            }
            	})
            },
            registCode (){
            	let params = this.registCodeParams;
            	params.mobile = this.registParams.mobile;
            	let item = this.judgeRule[0];

            	if(!item.func(params.mobile)){
            		this.tips = item.error;
            		return false;
            	}
            	if(params.authcode == ''){
					this.tips = '请输入图片验证码';
            		return false;
            	}
            	if(this.btnDisabled){
            		return;
            	}
            	let that = this;
            	registCode({
					account: this.registParams.mobile,
					img_code: this.registCodeParams.authcode,
					vtype: 'sms'
				}).then( result => {
            		if (result.code == '0') {
            			that.codeTimerNum = 120;
		                that.btnDisabled = true;
		                var timer = setInterval(function () {
		                    that.codeTimerNum--;
		                    if (that.codeTimerNum <= 0) {
		                        that.btnDisabled = false;
		                        clearInterval(timer);
		                        return;
		                    }
		                }, 1000);
		            } else {
		                alert("error");
		            }
            	})
            },
		}
	}
</script>
<style scoped>
	@import "./../../common/css/reg.css";
	@import "./../../common/css/h5Base.css";
    input[type="checkbox"]{
        width: .32rem;
        height: .32rem;
    }
    input::-webkit-input-placeholder {
		color: #999;
	}
	.main h3 {
		font-weight: bold;
	}
	img {
		vertical-align: top;
	}
	.mask {
		display: block;
	}
	.mask .mask-title{
		font-weight: bold;
	}
	.mask .mask-btn{
		padding: 0.08rem 0.33rem;
		font-size: 0.28rem;
	}
	
</style>


// WEBPACK FOOTER //
// src/pages/regist/registUser.vue